import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserService } from '../services/user.service';
import { AddCardComponent } from './add-card/add-card.component';
import { environment } from "../../environments/environment";
import { MatSnackBar } from '@angular/material/snack-bar';
 
@Component({
  selector: 'app-billing',
  templateUrl: './billing.component.html',
  styleUrl: './billing.component.scss',
  standalone: false
})
export class BillingComponent {
  saveButtonText = 'Save';
  is_ignite = false;
  billingForm: FormGroup;
  processing: any;
  client_secrets: any;
  constructor(private fb: FormBuilder, public userService: UserService, public dialog: MatDialog, public _snakeBar: MatSnackBar) {
    this.billingForm = this.fb.group({
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      address_1: ['', Validators.required],
      address_2: [''],
      city: ['', Validators.required],
      country: ['', Validators.required],
      state: ['', Validators.required],
      zip_code: ['', Validators.required]
    });
    // this.loadClientSecret();
 
  }
  countries = [
    { "code": "AL", "name": "Albania" },
    { "code": "AO", "name": "Angola" },
    { "code": "AM", "name": "Armenia" },
    { "code": "AW", "name": "Aruba" },
    { "code": "AU", "name": "Australia" },
    { "code": "AT", "name": "Austria" },
    { "code": "AZ", "name": "Azerbaijan" },
    { "code": "BS", "name": "Bahamas" },
    { "code": "BH", "name": "Bahrain" },
    { "code": "BD", "name": "Bangladesh" },
    { "code": "BB", "name": "Barbados" },
    { "code": "BY", "name": "Belarus" },
    { "code": "BE", "name": "Belgium" },
    { "code": "BJ", "name": "Benin" },
    { "code": "BA", "name": "Bosnia and Herzegovina" },
    { "code": "BG", "name": "Bulgaria" },
    { "code": "BF", "name": "Burkina Faso" },
    { "code": "KH", "name": "Cambodia" },
    { "code": "CM", "name": "Cameroon" },
    { "code": "CA", "name": "Canada" },
    { "code": "CV", "name": "Cape Verde" },
    { "code": "CL", "name": "Chile" },
    { "code": "CO", "name": "Colombia" },
    { "code": "CR", "name": "Costa Rica" },
    { "code": "HR", "name": "Croatia" },
    { "code": "CY", "name": "Cyprus" },
    { "code": "CZ", "name": "Czechia" },
    { "code": "DK", "name": "Denmark" },
    { "code": "EC", "name": "Ecuador" },
    { "code": "EG", "name": "Egypt" },
    { "code": "EE", "name": "Estonia" },
    { "code": "ET", "name": "Ethiopia" },
    { "code": "FI", "name": "Finland" },
    { "code": "FR", "name": "France" },
    { "code": "GE", "name": "Georgia" },
    { "code": "DE", "name": "Germany" },
    { "code": "GR", "name": "Greece" },
    { "code": "GN", "name": "Guinea" },
    { "code": "HK", "name": "Hong Kong" },
    { "code": "HU", "name": "Hungary" },
    { "code": "IS", "name": "Iceland" },
    { "code": "IN", "name": "India" },
    { "code": "ID", "name": "Indonesia" },
    { "code": "IE", "name": "Ireland" },
    { "code": "IT", "name": "Italy" },
    { "code": "JP", "name": "Japan" },
    { "code": "KZ", "name": "Kazakhstan" },
    { "code": "KE", "name": "Kenya" },
    { "code": "KG", "name": "Kyrgyzstan" },
    { "code": "LA", "name": "Laos" },
    { "code": "LV", "name": "Latvia" },
    { "code": "LI", "name": "Liechtenstein" },
    { "code": "LT", "name": "Lithuania" },
    { "code": "LU", "name": "Luxembourg" },
    { "code": "MY", "name": "Malaysia" },
    { "code": "MT", "name": "Malta" },
    { "code": "MR", "name": "Mauritania" },
    { "code": "MX", "name": "Mexico" },
    { "code": "MD", "name": "Moldova" },
    { "code": "ME", "name": "Montenegro" },
    { "code": "MA", "name": "Morocco" },
    { "code": "NP", "name": "Nepal" },
    { "code": "NL", "name": "Netherlands" },
    { "code": "NZ", "name": "New Zealand" },
    { "code": "NG", "name": "Nigeria" },
    { "code": "MK", "name": "North Macedonia" },
    { "code": "NO", "name": "Norway" },
    { "code": "OM", "name": "Oman" },
    { "code": "PE", "name": "Peru" },
    { "code": "PH", "name": "Philippines" },
    { "code": "PL", "name": "Poland" },
    { "code": "PT", "name": "Portugal" },
    { "code": "PR", "name": "Puerto Rico" },
    { "code": "RO", "name": "Romania" },
    { "code": "RU", "name": "Russia" },
    { "code": "SA", "name": "Saudi Arabia" },
    { "code": "SN", "name": "Senegal" },
    { "code": "RS", "name": "Serbia" },
    { "code": "SG", "name": "Singapore" },
    { "code": "SK", "name": "Slovakia" },
    { "code": "SI", "name": "Slovenia" },
    { "code": "ZA", "name": "South Africa" },
    { "code": "KR", "name": "South Korea" },
    { "code": "ES", "name": "Spain" },
    { "code": "SR", "name": "Suriname" },
    { "code": "SE", "name": "Sweden" },
    { "code": "CH", "name": "Switzerland" },
    { "code": "TW", "name": "Taiwan" },
    { "code": "TJ", "name": "Tajikistan" },
    { "code": "TZ", "name": "Tanzania" },
    { "code": "TH", "name": "Thailand" },
    { "code": "TR", "name": "Türkiye (Turkey)" },
    { "code": "UG", "name": "Uganda" },
    { "code": "UA", "name": "Ukraine" },
    { "code": "AE", "name": "United Arab Emirates" },
    { "code": "GB", "name": "United Kingdom" },
    { "code": "US", "name": "United States" },
    { "code": "UY", "name": "Uruguay" },
    { "code": "UZ", "name": "Uzbekistan" },
    { "code": "VN", "name": "Vietnam" },
    { "code": "ZM", "name": "Zambia" },
    { "code": "ZW", "name": "Zimbabwe" }
  ];
  ngOnInit() {
    const host = window.location.hostname;
    this.is_ignite = host === environment.igniteDomain;
 
    this.userService.billingInfoGet().subscribe((data: any) => {
      if (data) {
        this.billingForm.patchValue({
          first_name: data.first_name || '',
          last_name: data.last_name || '',
          address_1: data.address_1 || '',
          address_2: data.address_2 || '',
          city: data.city || '',
          country: data.country || '',
          state: data.state || '',
          zip_code: data.zip_code || ''
        });
 
      }
    }, error => {
      console.error("Error fetching billing info:", error);
    });
  }
  billingInfo() {
    if (this.billingForm.invalid) {
      console.log("Form is invalid", this.billingForm.errors);
      return;
    }
 
    console.log("Form Data:", this.billingForm.value);
 
    this.processing = true;
    this.userService.billingInfoUpdate(this.billingForm.value).subscribe(
      (response: any) => {
        this.processing = false;
        this.saveButtonText = 'Saved';
        setTimeout(() => {
          this.saveButtonText = 'Save';
        }, 1500);
 
        console.log("Payment method updated:", response);
        this._snakeBar.open("Billing address added successfully", "Dismiss")
        setTimeout(() => {
          this._snakeBar.dismiss();
        }, 5000);
      },
      (error: any) => {
        this.processing = false;
        console.error("Error updating payment method:", error);
      }
    );
  }
 
}